// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DigitalAssetFileNameByIdRequestModel from '../../model/digital-asset-file-name-by-id-request-model';
import DigitalAssetFileNameByIdRequestDTO from '../dto/digital-asset-file-name-by-id-request-dto';
import dtoSchema from '../schemas/digital-asset-file-name-by-id-request-schema';

export default abstract class DigitalAssetFileNameByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DigitalAssetFileNameByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<DigitalAssetFileNameByIdRequestDTO>): DigitalAssetFileNameByIdRequestModel;
  static toModel(dto: DeepPartial<DigitalAssetFileNameByIdRequestDTO> | undefined | null): DigitalAssetFileNameByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<DigitalAssetFileNameByIdRequestDTO> | undefined | null): DigitalAssetFileNameByIdRequestModel | undefined {
    return dto ? new DigitalAssetFileNameByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DigitalAssetFileNameByIdRequestModel> | DigitalAssetFileNameByIdRequestModel): DigitalAssetFileNameByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DigitalAssetFileNameByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DigitalAssetFileNameByIdRequestModel, can not map to DigitalAssetFileNameByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
